<template>
  <div class="tabs">
    <div class="tab-scroller hide-mobile">
      <ul class="nav nav-tabs" ref="navTabs" id="myTab" role="tablist">
        <li class="nav-item" v-for="(item, index) in tabs" :key="item.title">
          <a class="nav-anchor" :class="{ active: item.isActive }" @click.prevent="selectTab(index)">{{ item.title }}</a>
        </li>
      </ul>
    </div>

    <FormGroup class="hide-desktop">
      <Dropdown v-if="currentTab" fill :items="tabsForDropdown" @change="selectTab" >{{ currentTab.value }}</Dropdown>
    </FormGroup>
    <div class="tab-content" id="myTabContent">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Dropdown from './Dropdown.vue'
import FormGroup from './FormGroup.vue'
export default {
  name: 'Tabs',
  components: {
    Dropdown,
    FormGroup
  },
  props: {
    noScroll: Boolean
  },
  data () {
    return {
      children: [],
      selectedIndex: 0,
      mobile: true
    }
  },
  created () {
    this.children = this.$children
    this.$nextTick(() => {
    //   this.tabs = this.$children.filter((child) => {
    //     return child.$options._componentTag === 'Tab'
    //   })
    //   if (this.$route.query.tab && this.tabs[this.$route.query.tab]) {
    //     this.selectTab(parseInt(this.$route.query.tab))
    //   }
      if (this.$route.query.tab && this.tabs.find(tab => tab.name === this.$route.query.tab)) {
        this.selectTab(this.tabs.indexOf(this.tabs.find(tab => tab.name === this.$route.query.tab)))
      }
    })
  },
  computed: {
    tabs () {
      return this.children.filter(tab => tab.$options._componentTag === 'Tab')
    },
    currentTab () {
      return this.tabs[this.selectedIndex]
    },
    tabsForDropdown () {
      return this.tabs.map((tab, index) => {
        return {
          key: index,
          value: tab.value
        }
      })
    }
  },
  methods: {
    selectTab (i) {
      this.selectedIndex = i
      const tabName = this.tabs[i].name || i
      const args = {
        tab: tabName
      }
      if (this.noScroll) args.noScroll = 1
      this.$router.push({ path: this.$route.path, query: args })

      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-item {
  cursor: pointer;
  white-space: nowrap;

  &:not(:last-child) {
    margin-right: 0.2rem;
  }
}
.nav-anchor {
  padding: 0.6rem 0.4rem;
  display: inline-block;
}

.tab-scroller {
  overflow-x: auto;
  max-width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
}

.nav-tabs {
  display: flex;
  width: 100%;
}
.nav-anchor {
  padding: 7px 13px;
  background-color:#eee;
  border-bottom: 2px solid transparent;
  color:#222;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-anchor.active {
  border: 1px solid #eaeaea;
  border-bottom: 2px solid #38afe2;
  background-color: white;
}
.nav-anchor:hover {
  border: 1px solid #eaeaea;
  border-bottom: 2px solid #38afe2;
}
.tabs {
  margin-bottom: 1rem;
}
</style>
